jQuery( document ).ready( function( $ ) {
    $('.gcal-slider').unslider({
        nav: false
    });
}( jQuery ));


//////////////////
// WEBPACK FOOTER
// ./_src/admin/js/admin-gcal.dev.js
// module id = 1
// module chunks = 4